export interface HealthCheckResult {
  isConnected: boolean;
  error?: {
    type: 'NETWORK_ERROR' | 'SERVER_ERROR' | 'AUTH_ERROR' | 'UNKNOWN_ERROR';
    message: string;
    statusCode?: number;
  };
}

class HealthCheckService {
  // Health check using authenticated endpoint to verify token validity
  public async checkConnection(): Promise<HealthCheckResult> {
    try {
      const token = localStorage.getItem('cmt_token');
      
      if (!token) {
        return {
          isConnected: false,
          error: {
            type: 'AUTH_ERROR',
            message: 'No authentication token found'
          }
        };
      }

      // Use authenticated profile endpoint to check if token is still valid
      const response = await fetch(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_URL_VERSION}admin/profile`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      });
      
      // Check response status
      if (response.ok) {
        // Token is valid, server is working
        return {
          isConnected: true
        };
      } else if (response.status === 401 || response.status === 403) {
        // Token expired or invalid
        return {
          isConnected: false,
          error: {
            type: 'AUTH_ERROR',
            message: 'Authentication token expired or invalid',
            statusCode: response.status
          }
        };
      } else {
        // Other server errors
        return {
          isConnected: false,
          error: {
            type: 'SERVER_ERROR',
            message: `Server error: ${response.status}`,
            statusCode: response.status
          }
        };
      }
    } catch (error: any) {
      console.error('Health check failed:', error);
      
      // Network error (server down, no internet)
      if (!error.response && (error.name === 'TypeError' || error.message.includes('fetch'))) {
        return {
          isConnected: false,
          error: {
            type: 'NETWORK_ERROR',
            message: 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
          }
        };
      }
      
      // Server error (500, 503, etc.)
      return {
        isConnected: false,
        error: {
          type: 'SERVER_ERROR',
          message: 'เซิร์ฟเวอร์ขัดข้อง กรุณาลองใหม่อีกครั้ง',
        }
      };
    }
  }
}

export const healthCheckService = new HealthCheckService();
